import * as React from 'react';

import { cn } from '@/lib/utils';

import { badgeVariants } from './badge-variants';

// BadgeIcon component for animated icons
const BadgeIcon = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex items-center justify-center', className)} {...props} />
  )
);
BadgeIcon.displayName = 'BadgeIcon';

interface BadgeProps extends React.HTMLAttributes<HTMLElement> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'muted'
    | 'ghost'
    | 'outline'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
    | 'destructive'
    | 'elevated'
    | 'default';
  size?: 'sm' | 'md' | 'lg';
  radius?: 'sm' | 'md' | 'lg' | 'xl' | 'pill' | 'full';
  as?: React.ElementType;
}

const Badge = React.forwardRef<HTMLElement, BadgeProps>(
  (
    {
      className,
      variant = 'primary',
      size = 'md',
      radius = 'pill',
      as: Component = 'span',
      children,
      ...props
    },
    ref
  ) => {
    return (
      <Component
        ref={ref}
        className={cn(
          badgeVariants({
            variant,
            size,
            radius,
          }),
          className
        )}
        {...props}
      >
        {children}
      </Component>
    );
  }
);
Badge.displayName = 'Badge';

export { Badge, BadgeIcon };
